import { render, staticRenderFns } from "./page-progress-component.vue?vue&type=template&id=f83c2fd4&scoped=true&"
import script from "./page-progress-component.vue?vue&type=script&lang=ts&"
export * from "./page-progress-component.vue?vue&type=script&lang=ts&"
import style0 from "./page-progress-component.vue?vue&type=style&index=0&id=f83c2fd4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f83c2fd4",
  null
  
)

export default component.exports